<template>
  <a :class="['card',name]" href="#">
    
    <div class="card__header">
      <div class="icon">
        <slot name="icon">Icon</slot>
      </div>
      <div class="tag" :class="name">
        <span>
          <slot name="tag">Tag</slot>
        </span>
      </div>
    </div>

    <div class="heading">
      <slot name="heading">Heading</slot>
    </div>
    
    <div class="link">
      View
      <svg-arrow-extra-long></svg-arrow-extra-long>
    </div>

  </a>
</template>

<script>
	export default {
		name: 'HeroCard',

		props: {
			name: {
        type: String,
        default: 'default'
      }
		},

		data() {
			return {
	
			}
		},

		created() {
			
		},

		mounted() {
			
		},

		methods: {
			
		},

		computed: {
			
		}
	}
</script>
